import { render, staticRenderFns } from "./Vacancy.vue?vue&type=template&id=65477c02"
import script from "./Vacancy.vue?vue&type=script&lang=js"
export * from "./Vacancy.vue?vue&type=script&lang=js"
import style0 from "./Vacancy.vue?vue&type=style&index=0&id=65477c02&prod&lang=scss"
import style1 from "./Vacancy.vue?vue&type=style&index=1&id=65477c02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports